import React, { useEffect, useState } from "react";
import { TechFlipCard } from "./TechFlipCard";
import styles from "./TechRow.module.css";

import csharp from "../assets/icons/csharp.svg";
import dotnet from "../assets/icons/dotnet.svg";
import reactLogo from "../assets/icons/react.svg";
import tsLogo from "../assets/icons/typescript.svg";
import python from "../assets/icons/python.svg";
import fastapi from "../assets/icons/fastapi.svg";
import azure from "../assets/icons/azure.svg";
import aws from "../assets/icons/aws.svg";


const techPairs = [
    { front: csharp, back: dotnet },
    { front: reactLogo, back: tsLogo },
    { front: python, back: fastapi },
    { front: azure, back: aws }
];


export const TechRow: React.FC = () => {
    // Track which side is showing for each card
    const [flippedStates, setFlippedStates] = useState<boolean[]>(Array(techPairs.length).fill(false));
    const [activeIndex, setActiveIndex] = useState<number>(0);

    useEffect(() => {
        let index = 0;
        const interval = setInterval(() => {
            setActiveIndex(index);
            setFlippedStates((prev) => {
                // Flip only the current card
                const newStates = [...prev];
                newStates[index] = !newStates[index];
                return newStates;
            });
            index = (index + 1) % techPairs.length;
        }, 1500);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles.techFlipGrid}>
            {techPairs.map((pair, i) => (
                <TechFlipCard
                    key={i}
                    front={pair.front}
                    back={pair.back}
                    isFlipped={flippedStates[i]}
                />
            ))}
        </div>
    );
};
